<script setup lang="ts">
import { type RouteLocationNamedI18n } from 'vue-router';

type ResultItem = {
    id: string;
    slug: string;
    vin: string;
    brand: string;
    model: string;
    coverImage: string | null;
    price: number | null;
};

// PROPS
interface Props {
    titleKey: TranslationKey;
    viewAllKey: TranslationKey;
    items: ResultItem[];
    total: number;
    routeName: string;
    viewAllRoute: RouteLocationNamedI18n;
    highlightOffset?: number;
    getHighlightClass?: (idx: number) => string;
}

const { highlightOffset = 0, getHighlightClass = (): string => '' } = defineProps<Props>();

defineEmits<{ itemClick: [] }>();

const { tt } = useTypedI18n();
</script>

<template>
    <section v-if="items.length > 0">
        <h3 class="px-2 pb-1 text-xs font-semibold text-neutral-500 uppercase">
            {{ tt(titleKey, { count: total }) }}
        </h3>
        <ul>
            <li v-for="(item, idx) in items" :key="item.id">
                <HeaderSearchResultItem
                    :slug="item.slug"
                    :vin="item.vin"
                    :brand="item.brand"
                    :model="item.model"
                    :cover-image="item.coverImage"
                    :price="item.price"
                    :route-name="routeName"
                    :highlight-class="getHighlightClass(highlightOffset + idx)"
                    @click="$emit('itemClick')"
                />
            </li>
        </ul>
        <NuxtLinkLocale
            v-if="total > items.length"
            :to="viewAllRoute"
            class="text-primary-600 block px-2 py-1 text-xs hover:underline"
            @click="$emit('itemClick')"
        >
            {{ tt(viewAllKey, { count: total }) }}
        </NuxtLinkLocale>
    </section>
</template>
